import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import PrivacyPage from './routes/PrivacyPage';
import { AboutPage } from './routes/AboutPage';
import ServiceDetailPage from './routes/ServiceDetailPage';
import KvkkBasvuruFormuPage from './routes/legal/KvkkBasvuruFormuPage';
import AydinlatmaMetniPage from './routes/legal/AydinlatmaMetniPage';
import OnBilgilendirmeFormuPage from './routes/legal/OnBilgilendirmeFormuPage';
import MesafeliSatisSozlesmesiPage from './routes/legal/MesafeliSatisSozlesmesiPage';
import IptalIadeKosullariPage from './routes/legal/IptalIadeKosullariPage';
import KullanimSartlariPage from './routes/legal/KullanimSartlariPage';
import BlogPage from './routes/BlogPage';
import './styles/globals.css'
import './i18n';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();
const LOADED_FLAG = 'ins-site-loaded';

if (typeof window !== 'undefined') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
  }

  if (document.readyState === 'complete') {
    window.sessionStorage.setItem(LOADED_FLAG, 'true');
  } else {
    window.addEventListener(
      'load',
      () => {
        window.sessionStorage.setItem(LOADED_FLAG, 'true');
      },
      { once: true }
    );
  }
}

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/kurumsal', element: <AboutPage /> },
  { path: '/hakkimizda', element: <AboutPage /> },
  { path: '/projeler/:slug', element: <ServiceDetailPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/kvkk-basvuru-formu', element: <KvkkBasvuruFormuPage /> },
  { path: '/aydinlatma-metni', element: <AydinlatmaMetniPage /> },
  { path: '/on-bilgilendirme-formu', element: <OnBilgilendirmeFormuPage /> },
  { path: '/mesafeli-satis-sozlesmesi', element: <MesafeliSatisSozlesmesiPage /> },
  { path: '/iptal-iade-kosullari', element: <IptalIadeKosullariPage /> },
  { path: '/kullanim-sartlari', element: <KullanimSartlariPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback="Loading...">
          <RouterProvider router={router} />
        </Suspense>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
)
